import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { useI18n } from "../i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LOGO_URL } from "../brand";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch { setSent(true); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm fade-in">
        <div className="mb-8 flex justify-center"><div className="rounded-lg bg-[#F7F2EA] p-3"><img src={LOGO_URL} alt="Urban Dreams Home" className="h-14 w-auto object-contain" /></div></div>
        <h1 className="font-head text-2xl font-semibold text-slate-900">{t("resetPassword")}</h1>
        {sent ? (
          <div data-testid="forgot-sent" className="mt-6 flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
            <MailCheck size={18} className="mt-0.5" /> {t("resetLinkSent")}
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">{t("email")}</Label>
              <Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" required />
            </div>
            <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90">{loading ? "…" : t("sendResetLink")}</Button>
          </form>
        )}
        <Link to="/login" data-testid="back-to-login" className="mt-6 flex items-center justify-center gap-1 text-sm text-slate-500 hover:text-primary"><ArrowLeft size={14} /> {t("backToLogin")}</Link>
      </div>
    </div>
  );
}
